<app-header></app-header>

<div class="min-h-screen tema-claro">
  <div class="max-w-7xl mx-auto p-6">

    <!-- Breadcrumb -->
    <div class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <a routerLink="/lancamentos-financeiros" class="hover:underline" style="color: var(--brand-primary)">Lançamentos Financeiros</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Análise de Caixas</span>
    </div>

    <div class="bg-white rounded-2xl shadow-sm overflow-hidden" style="border: 1px solid var(--flua-borda)">

      <!-- Header -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: var(--thead)">
        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"/>
          </svg>
          <span class="font-semibold text-sm text-white">Análise de Caixas por Unidade</span>
        </div>
        <button (click)="voltar()" class="p-1 text-white hover:opacity-75">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Toolbar -->
      <div class="px-6 py-4 flex flex-wrap items-end gap-3" style="border-bottom: 1px solid var(--flua-borda); background-color: var(--flua-rodape)">
        <div>
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Unidade</label>
          <select [(ngModel)]="filtroUnidade" class="px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda); min-width: 200px">
            <option value="">Todas</option>
            <option *ngFor="let u of unidadesDistintas" [value]="u.id">{{ u.name }}</option>
          </select>
        </div>
        <div>
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Status</label>
          <select [(ngModel)]="filtroStatus" class="px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda); min-width: 200px">
            <option value="TODOS">Todos</option>
            <option value="ABERTOS_OK">Aberto (OK)</option>
            <option value="PRECISA_SANGRIA">Precisa sangrar (&gt; R$ 1.000)</option>
            <option value="FECHADO_COM_SOBRA">Fechado com sobra (&gt; R$ 200)</option>
            <option value="FECHADO_OK">Fechado (OK)</option>
          </select>
        </div>
        <div class="flex-1 min-w-[200px]">
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Buscar</label>
          <input type="text" [(ngModel)]="filtroBusca" placeholder="Nome do caixa ou usuário"
                 class="w-full px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda)"/>
        </div>
        <button (click)="carregar()" [disabled]="isLoading"
                class="px-4 py-1.5 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
                [style.backgroundColor]="isLoading ? '#D6CFC2' : 'var(--brand-primary)'">
          <div *ngIf="isLoading" class="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
          {{ isLoading ? 'Carregando...' : 'Atualizar' }}
        </button>
      </div>

      <!-- Totais -->
      <div class="px-6 py-3 flex flex-wrap gap-x-6 gap-y-2 text-xs" style="border-bottom: 1px solid var(--flua-borda); background-color: var(--flua-rodape)">
        <div><span style="color: var(--tx-2)">Total:</span> <strong style="color: var(--tx)">{{ totais.total }}</strong></div>
        <div><span style="color: var(--tx-2)">Abertos:</span> <strong style="color: #166534">{{ totais.abertos }}</strong></div>
        <div><span style="color: var(--tx-2)">Precisa sangrar:</span> <strong style="color: #9a3412">{{ totais.precisaSangria }}</strong></div>
        <div><span style="color: var(--tx-2)">Fechado c/ sobra:</span> <strong style="color: #991b1b">{{ totais.fechadoSobra }}</strong></div>
        <div class="ml-auto"><span style="color: var(--tx-2)">Inicial:</span> <strong style="color: var(--tx)">{{ formatCurrency(totais.saldoInicialTotal) }}</strong></div>
        <div><span style="color: var(--tx-2)">Entradas:</span> <strong style="color: #00AC70">{{ formatCurrency(totais.entradasTotal) }}</strong></div>
        <div><span style="color: var(--tx-2)">Saídas:</span> <strong style="color: #dc2626">{{ formatCurrency(totais.saidasTotal) }}</strong></div>
        <div><span style="color: var(--tx-2)">Cancelados:</span> <strong style="color: #9a3412">{{ formatCurrency(totais.canceladosTotal) }}</strong></div>
        <div><span style="color: var(--tx-2)">Final:</span> <strong style="color: var(--brand-primary)">{{ formatCurrency(totais.saldoTotal) }}</strong></div>
      </div>

      <!-- Erro -->
      <div *ngIf="erro" class="px-6 py-3" style="background-color: #fef2f2; color: #991b1b">
        <span class="text-xs">{{ erro }}</span>
      </div>

      <!-- Tabela -->
      <div class="overflow-x-auto">
        <table class="w-full text-xs">
          <thead>
            <tr style="background-color: var(--thead)">
              <th class="px-4 py-3 text-left text-white font-semibold">Caixa</th>
              <th class="px-4 py-3 text-left text-white font-semibold">Unidade</th>
              <th class="px-4 py-3 text-left text-white font-semibold">Usuário</th>
              <th class="px-4 py-3 text-left text-white font-semibold">Data Saldo</th>
              <th class="px-4 py-3 text-right text-white font-semibold">Saldo Inicial</th>
              <th class="px-4 py-3 text-right text-white font-semibold">Entradas</th>
              <th class="px-4 py-3 text-right text-white font-semibold">Saídas</th>
              <th class="px-4 py-3 text-right text-white font-semibold">Cancelados</th>
              <th class="px-4 py-3 text-right text-white font-semibold">Saldo Final</th>
              <th class="px-4 py-3 text-center text-white font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="10" class="px-4 py-8 text-center" style="color: var(--tx-2)">Carregando...</td>
            </tr>
            <tr *ngIf="!isLoading && caixasFiltrados.length === 0">
              <td colspan="10" class="px-4 py-8 text-center" style="color: var(--tx-2)">Nenhum caixa encontrado.</td>
            </tr>
            <tr *ngFor="let c of caixasFiltrados" style="border-bottom: 1px solid var(--flua-borda)">
              <td class="px-4 py-2.5" style="color: var(--tx)"><strong>{{ c.name }}</strong></td>
              <td class="px-4 py-2.5" style="color: var(--tx-2)">{{ c.establishmentName }}</td>
              <td class="px-4 py-2.5" style="color: var(--tx-2)">{{ c.username || '—' }}</td>
              <td class="px-4 py-2.5" style="color: var(--tx-2)">{{ formatDate(c.balanceDate) }}</td>
              <td class="px-4 py-2.5 text-right font-mono" style="color: var(--tx-2)">{{ formatCurrency(c.initialBalance) }}</td>
              <td class="px-4 py-2.5 text-right font-mono" style="color: #00AC70">{{ formatCurrency(c.ingressBalance) }}</td>
              <td class="px-4 py-2.5 text-right font-mono" style="color: #dc2626">{{ formatCurrency(c.egressBalance) }}</td>
              <td class="px-4 py-2.5 text-right font-mono" style="color: #9a3412">{{ formatCurrency(c.cancelledBalance) }}</td>
              <td class="px-4 py-2.5 text-right font-mono" style="color: var(--tx)"><strong>{{ formatCurrency(c.currentBalance) }}</strong></td>
              <td class="px-4 py-2.5 text-center">
                <span class="px-2 py-1 rounded text-[11px] font-semibold"
                      [style.backgroundColor]="statusBg(status(c))"
                      [style.color]="statusFg(status(c))">
                  {{ statusLabel(status(c)) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
